<h2>Permisos</h2>
<div *ngIf="user" class="permissions-table">
    <div class="table-header">
        <div class="header-cell">Progreso</div>
        <div class="header-cell">Etapa</div>
        <div class="header-cell">Estado</div>
        <div class="header-cell">Acciones</div>
    </div>

    <div class="table-body">
        <div class="table-row" *ngFor="let item of permissions">
            <div class="table-cell name-cell" [class.active]="item.active">{{ item.name }}</div>
            <div class="table-cell stage-cell">{{ item.stage }}</div>
            <div class="table-cell status-cell">
                <ul>
                    <li [class.active]="item.active">{{ item.active ? 'Activado' : 'Desactivado' }}</li>
                </ul>
            </div>

            <div class="table-cell actions-cell">
                <app-generic-toggle-switch [(ngModel)]="item.active" name="active" (changeEvent)="changeActive($event, item)" />
                <!-- <button class="action-button" (click)="view(item)">
                    Ver
                </button> -->
            </div>
        </div>
    </div>
</div>